import React, { Component } from 'react';
import Paper from '@mui/material/Paper';
import UsersApi from '../../api/users';
import { connect } from 'react-redux';
import Config from '../../config/env';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
class UserActions extends Component {
  state = {
    calling: false,
    reminding: false,
    following_up: false,
    sending_analysis: false,
    activating_platinum: false,
    activating_gold: false
  };
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  call = () => {
    this.props.confirmAction(
      'You are going to send an email to this user requesting to schedule a call with you. Do you want to proceed?',
      () =>
        this.setState({ calling: true }, () =>
          UsersApi.call(this.props.account._id)
            .then(
              success =>
                this.setState({ calling: false }, () =>
                  this.props.showMessage(
                    'An email has been sent to the user requesting to schedule a call.'
                  )
                ),
              error => this.setState({ calling: false }, this.props.showError)
            )
            .catch(error =>
              this.setState({ calling: false }, this.props.showError)
            )
        )
    );
  };
  activateMembership = (tier, token = '') => {
    this.setState(
      { [`activating_${tier == 1 ? 'platinum' : 'gold'}`]: true },
      () =>
        UsersApi.activate(this.props.account._id, tier, token)
          .then(
            success =>
              this.setState(
                { [`activating_${tier == 1 ? 'platinum' : 'gold'}`]: false },
                () => {
                  this.props.showMessage(
                    'The user membership has been activated.'
                  );
                  this.props.onActivated();
                }
              ),
            error =>
              this.setState(
                { [`activating_${tier == 1 ? 'platinum' : 'gold'}`]: false },
                this.props.showError
              )
          )
          .catch(error =>
            this.setState(
              { [`activating_${tier == 1 ? 'platinum' : 'gold'}`]: false },
              this.props.showError
            )
          )
    );
  };
  
  renderActionTab = () => {
    return (
      <div className="animated fadeIn padding">
        {
        this.props.account.loanType === 'private' ? (
          <div className="col-12">
            <p className="text-center">
              This view is not available to this user because he/she as private
              loan
            </p>
          </div>
        ) : (
          <>
            {(this.props.account.analysis && !this.props.account.analysis.approved ||
              this.props.account.status == 'analysis' ||
              this.props.account.status == 'forms') && (
              <div className="row">
                <div className="col-12">
                  <p className="text-center">
                    The strategy or forms for this user have not been approved
                    yet, please contact a Student Loans coach.
                  </p>
                </div>
              </div>
            )}

            {this.props.account.status == 'guest' && (
              <div className="row">
                <div className="col-4 offset-2">
                  <Paper>
                    <div className="action">
                      <h1>Request to Schedule a Call</h1>
                      <p>
                        Send an email to the user requesting to schedule a call
                        to discuss Student Loans.
                      </p>
                      <button
                        onClick={this.call}
                        disabled={this.state.calling}
                        className="btn btn-primary loading"
                      >
                        Request to Schedule a Call
                      </button>
                    </div>
                  </Paper>
                </div>
              </div>
            )}
            {parseInt(this.props.account.membership) !== 1 && <div className="col-4 offset-2">
              <Paper>
                <div className="action">
                  <h1>Activate Platinum Account</h1>
                  <p>
                    If you have converted this user offline, use this option to
                    Activate the user's account with a Platinum Membership.
                  </p>
                  <button
                    disabled={this.state.activating_platinum}
                    onClick={() => this.activateMembership(1)}
                    className="btn btn-primary loading"
                  >
                    Activate Platinum Account
                  </button>
                </div>
              </Paper>
            </div>}
          </>
        )}
      </div>
    )
  }

  render() {
    return (
      <>
        {this.props.account.analysis ? this.renderActionTab() : (
          <div className="col-12">
            <p className="text-center">
              This view is not available to this user because does not have an analysis
            </p>
          </div>
        )}
      </>
    );
  }
}
export default connect(null, { showError, showMessage, confirmAction })(
  UserActions
);
